/* THE SHIPPING PROMISE ON THE ORDER (Oct 14, Maks's spec, jarvis 22276). Every add to cart from an item page carries the
   shipping line the buyer saw, as two hidden line-item properties (the underscore keeps them out of the cart, checkout and
   emails, like _Wholesaler):
   - _ship_line: the line as the page shows it for the selected size or color at the moment of adding;
   - _ship_window: the same promise in business days, "2-5" or "10-15".
   Read at the moment of adding, so it always follows the variant picked. The line comes from #stocktxt (the new item page and
   the chain page) or the shown [data-hb-stock] block (the old template). Only lines whose variant belongs to this page's
   product get it, so a paired pendant or a bundle piece never inherits the chain's promise. Covers fetch to /cart/add(.js)
   (JSON, FormData, urlencoded), form posts, and form.submit() (which fires no submit event). Loaded on product pages only
   (layout/theme.liquid). */
(function () {
  if (window.__shipPromise) return;
  window.__shipPromise = 1;

  var meta = window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product;
  var IDS = {};
  ((meta && meta.variants) || []).forEach(function (v) { IDS[String(v.id)] = 1; });
  function ours(id) { return !!IDS[String(id || '').replace(/\D/g, '')]; }

  function line() {
    var el = document.getElementById('stocktxt');
    if (!el || !el.textContent.trim()) {
      var blocks = document.querySelectorAll('[data-hb-stock]');
      for (var i = 0; i < blocks.length; i++) { if (!blocks[i].hidden) { el = blocks[i].querySelector('p'); break; } }
    }
    if (!el) return '';
    var t = el.textContent.replace(/\s+/g, ' ').trim();
    // the international note is not the timing promise
    return t.split(' · ').filter(function (s) { return !/^International shipping/i.test(s); }).join(' · ').slice(0, 250);
  }
  function windowOf(t) {
    var m = t.match(/(\d+)\s*(?:to|-|–)\s*(\d+)\s*business days/i);
    return m ? m[1] + '-' + m[2] : '';
  }
  function props() {
    var l = line();
    if (!l) return null;
    var p = { _ship_line: l }, w = windowOf(l);
    if (w) p._ship_window = w;
    return p;
  }

  // JSON bodies: {id, quantity, properties} or {items:[...]}
  function addToJson(obj, p) {
    var list = Array.isArray(obj.items) ? obj.items : [obj];
    list.forEach(function (it) {
      if (!it || !ours(it.id)) return;
      it.properties = it.properties || {};
      for (var k in p) { if (it.properties[k] == null) it.properties[k] = p[k]; }
    });
    return obj;
  }
  // FormData / URLSearchParams: "id" or "items[i][id]"
  function addToPairs(fd, p) {
    var ids = [];
    fd.forEach(function (v, k) {
      if (k === 'id') ids.push({ pre: 'properties', id: v });
      var m = k.match(/^items\[(\d+)\]\[id\]$/);
      if (m) ids.push({ pre: 'items[' + m[1] + '][properties]', id: v });
    });
    ids.forEach(function (x) {
      if (!ours(x.id)) return;
      for (var k in p) { var name = x.pre + '[' + k + ']'; if (!fd.has(name)) fd.append(name, p[k]); }
    });
  }
  function isAdd(url) { return /\/cart\/add(\.js)?(\?|$)/.test(String(url || '')); }

  var f = window.fetch;
  if (f) {
    window.fetch = function (input, init) {
      try {
        var url = typeof input === 'string' ? input : input && input.url;
        var method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
        var p = isAdd(url) && method === 'POST' && init && init.body ? props() : null;
        if (p) {
          var b = init.body;
          if (typeof FormData !== 'undefined' && b instanceof FormData) addToPairs(b, p);
          else if (typeof URLSearchParams !== 'undefined' && b instanceof URLSearchParams) addToPairs(b, p);
          else if (typeof b === 'string') {
            var s = b.trim();
            if (s.charAt(0) === '{') init = Object.assign({}, init, { body: JSON.stringify(addToJson(JSON.parse(s), p)) });
            else { var u = new URLSearchParams(s); addToPairs(u, p); init = Object.assign({}, init, { body: u.toString() }); }
          }
        }
      } catch (e) {}
      return f.call(this, input, init);
    };
  }

  // real form posts: hidden inputs right before the form goes
  function stamp(form) {
    try {
      if (!form || !isAdd(form.getAttribute('action'))) return;
      var p = props();
      if (!p) return;
      var targets = [];
      var one = form.querySelector('[name="id"]');
      if (one) targets.push({ pre: 'properties', id: one.value });
      [].forEach.call(form.querySelectorAll('[name^="items["][name$="][id]"]'), function (el) {
        var m = el.name.match(/^items\[(\d+)\]\[id\]$/);
        if (m) targets.push({ pre: 'items[' + m[1] + '][properties]', id: el.value });
      });
      targets.forEach(function (t) {
        if (!ours(t.id)) return;
        for (var k in p) {
          var name = t.pre + '[' + k + ']', inp = form.querySelector('input[name="' + name + '"][data-ship-promise]');
          if (!inp) {
            if (form.querySelector('[name="' + name + '"]')) continue;
            inp = document.createElement('input');
            inp.type = 'hidden'; inp.name = name; inp.setAttribute('data-ship-promise', '');
            form.appendChild(inp);
          }
          inp.value = p[k];
        }
      });
    } catch (e) {}
  }
  document.addEventListener('submit', function (e) { stamp(e.target); }, true);
  var sub = HTMLFormElement.prototype.submit;
  HTMLFormElement.prototype.submit = function () { stamp(this); return sub.apply(this, arguments); };
  // handlers that build FormData from the form on click: stamp on the press, before they read it
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('button, input[type="submit"]');
    if (b && b.form) stamp(b.form);
  }, true);
})();
